module.exports = __webpack_public_path__ + "img/trial3-1.420626fe.png";